import React from 'react';
import CardSecurityCode from '../react-card-security-code';
import AppStore from '../stores/AppStore';
import * as AppActions from '../actions/AppActions';
import { localsMessages, guestLocalsMessages } from '../utility/getTemplateData';
import { Text } from '@paypalcorp/pp-react'

const guestMessages = guestLocalsMessages('guest/guestForm');
const errorMessages = localsMessages('errors/service');

class CVVComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      securityCode: '',
      cardSpec: AppStore.getCardSpec().cardSpec,
  //     cardSpec: {
		// "name": "Visa",
		// "type": "visa",
		// "fields": {
		//     "ccNumber": {
		//         "required": true,
		//         "editable": false,
		//         "pattern": "[0-9]+",
		//         "autodetect": "4[0-9]*",
		//         "maxlength": 16,
		//         "minlength": 13
		//     },
		//     "expirationDate": {
		//         "required": true,
		//         "pattern": "(0[1-9]|1[012])[/]((20)[0-9]{2}|[0-9]{2})",
		//         "maxlength": 7
		//     },
		//     "csc": {
		//         "required": true,
		//         "pattern": "[0-9]{3}",
		//         "maxlength": 3,
		//         "minlength": 3
		//     }
		// },
		// "logoUrl": "https://www.paypalobjects.com/en_US/i/logo/logo_ccVisa.gif"
		// },
      errorMessageCSC: '',
    }
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  handleChangeSecurityCode(securityCode) {
    this.setState({ securityCode: securityCode });
    this.props.handleSecurityCodeChange(securityCode);
  }

  handleFieldFocus(fieldName) {
    this.setState({ [fieldName]: '' });
  }

  /*
  * Handle error message for selected field
  */
  handleFieldBlur(value, fieldName, fieldRequired, fieldInvalid) {
    let newErrorState = {};

    if (value) {
      newErrorState = { [fieldName]: this.validateInputValue(value, fieldName, fieldInvalid) }
    } else {
      newErrorState = { [fieldName]: errorMessages[fieldRequired] }
    }

    this.setState(newErrorState)
  }

  /*
  * Validate input
  */
  validateInputValue(value, fieldName, fieldInvalid) {

    let { cardSpec : { fields: { csc = {} } } } = this.state;

    if (fieldName === 'errorMessageCSC') {
      let cscLen = value && value.length
      let cscMax = csc.maxlength
      let cscMin = csc.minlength || cscMax

      if (!(cscLen >= cscMin && cscLen <= cscMax)) {
        return errorMessages[fieldInvalid]
      }
    }

    return ''
  }

  render() {
    let { cscplaceholder, csc: cscLabel, cscnote } = guestMessages.guestLabels;
    cscnote = cscnote && cscnote.replace('{csc}', cscLabel.toLowerCase());

    return (
      <div className="cvv_component" id="cvv_component">
        <div  className="cvv_field">
          <CardSecurityCode
              showIsRequiredError={true}
              label={cscLabel}
              placeholder={cscplaceholder}
              errorMessage={this.state.errorMessageCSC}
              handleChangeSecurityCode={(value) => this.handleChangeSecurityCode(value)}
              handleFocus={(value) => this.handleFieldFocus('errorMessageCSC')}
              handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageCSC', 'REQUIRED_SECURITY_CODE', 'INVALID_SECURITY_CODE')}
              cardSpec={this.state.cardSpec}
            />
        </div>
        <Text
        	className="cvv-note no-margins"
        	size="sm"
        >{cscnote}</Text>
      </div>
    );
  }
};

export default CVVComponent;
